import { useThree } from '@react-three/fiber';
import { useControls, button, folder } from 'leva';

export function ViewerControls() {
  const { gl, scene, camera } = useThree();

  const takeScreenshot = () => {
    gl.render(scene, camera);
    const dataURL = gl.domElement.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = dataURL;
    link.download = "screenshot.png";
    link.click();
  };

  useControls(() => ({
    Utilities: folder({
      "Take Screenshot": button(takeScreenshot),
    }, { collapsed: true }) 
  }));

  return null;
}
